import type { RouteRecordRaw } from 'vue-router';

export default [
  {
    path: '/auth/callback',
    name: 'AuthCallback',
    component: () => import('@/pages/auth/auth-callback.vue'),
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('@/pages/errors/404.vue'),
  },
] as RouteRecordRaw[];
